// 📄 src/capabilities/featureKeys.js

export const FK = {
  // ✅ Dashboard (align with Permission.Code: DASHBOARD.VIEW)
  DASHBOARD_VIEW: "DASHBOARD.VIEW",
  // ✅ CRM (These are not in the Permission dump you shared; keep them as-is for now)
  CRM_WORKSPACE_VIEW: "CRM.WORKSPACE.VIEW",
  CRM_CONTACT_VIEW: "CRM.CONTACT.VIEW",
  CRM_TAGS_VIEW: "CRM.TAGS.VIEW",
  CRM_REMINDERS_VIEW: "CRM.REMINDERS.VIEW",
  CRM_TIMELINE_VIEW: "CRM.TIMELINE.VIEW",
  CRM_ATTRIBUTE_VIEW: "CRM.ATTRIBUTE.VIEW",
  // ✅Catalog (align with Permission.Code: PRODUCT.VIEW / CREATE / DELETE)
  CATALOG_WORKSPACE_VIEW: "CATALOG.WORKSPACE.VIEW",
  CATALOG_CREATE: "CATALOG.CREATE",
  CATALOG_DELETE: "CATALOG.DELETE",
  CATALOG_AUTOMATION: "CATALOG.AUTOMATION",

  // ✅ Campaigns (align with Permission.Code: CAMPAIGN.VIEW / CREATE / DELETE)
  CAMPAIGN_WORKSPACE_VIEW: "CAMPAIGN.WORKSPACE.VIEW",
  CAMPAIGN_BUILDER: "CAMPAIGN.BUILDER",
  CAMPAIGN_LIST_VIEW: "CAMPAIGN.LIST.VIEW",
  CAMPAIGN_STATUS_VIEW: "CAMPAIGN.STATUS.VIEW",
  CAMPAIGN_CTA_MANAGEMENT: "CAMPAIGN.CTA.MANAGEMENT",

  // ✅ Messaging (align fully with Permission.Code)
  MESSAGING_WORKSPACE_VIEW: "MESSAGING.WORKSPACE.VIEW",
  MESSAGING_SEND_TEXT: "MESSAGING.SEND.TEXT",
  MESSAGING_SEND_TEMPLATE: "MESSAGING.SEND.TEMPLATE",
  MESSAGING_REPORT_VIEW: "MESSAGING.REPORT.VIEW",

  // ✅ Automation Workspace (align with Permission.Code list you shared)
  AUTOMATION_WORKSPACE_VIEW: "AUTOMATION.WORKSPACE.VIEW",
  AUTOMATION_CREATE_BOT: "AUTOMATION.CREATE.BOT",
  AUTOMATION_VIEW_FLOW_MANAGE: "AUTOMATION.VIEW.FLOW.MANAGE",
  AUTOMATION_VIEW_FLOW_ANALYTICS: "AUTOMATION.VIEW.FLOW.ANALYTICS",
  AUTOMATION_CREATE_TEMPLATE_FLOW: "AUTOMATION.CREATE.TEMPLATE.FLOW",
  AUTOMATION_TRIGGER_TEST: "AUTOMATION.TRIGGER.TEST",

  // ✅ INBOX  workspace (align with Permission.Code)
  INBOX_WORKSPACE_VIEW: "INBOX.WORKSPACE.VIEW",
  INBOX_VIEW: "INBOX.VIEW",
  INBOX_CHAT_VIEW: "INBOX.CHAT.VIEW",
  INBOX_CHAT_ASSIGN: "INBOX.CHAT.ASSIGN", // added for chat assignment but it's not menu based

  // ✅ Superadmin workspace (align with Permission.Code)
  SUPER_ADMIN_WORKSPACE_VIEW: "SUPER.ADMIN.WORKSPACE.VIEW",
  SUPER_ADMIN_NEW_BUSINESS_APPROVAL: "SUPER.ADMIN.NEW.BUSINESS.APPROVAL",
  SUPER_ADMIN_PLAN_MANAGER_VIEW: "SUPER.ADMIN.PLAN.MANAGER.VIEW",
  SUPER_ADMIN_PLAN_PERMISSIONS_LIST: "SUPER.ADMIN.PLAN.PERMISSIONS.LIST",
  SUPER_ADMIN_ESU_DEBUG: "SUPER.ADMIN.ESU.DEBUG",
  SUPER_ADMIN_SIGNUP_REPORT_VIEW: "SUPER.ADMIN.SIGNUP.REPORT.VIEW",
  SUPER_ADMIN_BUSINESS_OVERVIEW: "SUPER.ADMIN.BUSINESS.OVERVIEW",
  SUPER_ADMIN_WEBHOOK_MONITOR: "SUPER.ADMIN.WEBHOOK.MONITOR",
  SUPER_ADMIN_USER_MANAGEMENT_VIEW: "SUPER.ADMIN.USER.MANAGEMENT.VIEW", // from Permission code
  SUPER_ADMIN_FLOW_EXECUTION_EXPLORER_VIEW:
    "SUPER.ADMIN.FLOW.EXECUTION.EXPLORER.VIEW",

  // ✅ Settings workspace (align with Permission.Code where known)
  SETTINGS_WORKSPACE_VIEW: "SETTINGS.WORKSPACE.VIEW", // from Permission code
  SETTINGS_WHATSAPP_SETTINGS_VIEW: "SETTINGS.WHATSAPP.SETTINGS.VIEW", // from Permission code
  SETTINGS_THEME_UPDATE: "SETTINGS.THEME.UPDATE", // no Permission.Code yet
  SETTINGS_PASSWORD_UPDATE: "SETTINGS.PASSWORD.UPDATE", // no Permission.Code yet
  SETTINGS_PROFILE_VIEW: "SETTINGS.PROFILE.VIEW", // from Permission code
  SETTINGS_META_ACCOUNT_MANAGEMENT: "SETTINGS.META.ACCOUNT.MANAGEMENT", // no Permission.Code yet
  SETTINGS_BILLING_VIEW: "SETTINGS.BILLING.VIEW",
  SETTINGS_PROFILE_UPDATE: "SETTINGS.PROFILE.UPDATE",
  SETTINGS_ROLE_PERMISSIONS_MAPPING: "SETTINGS.ROLE.PERMISSIONS.MAPPING",
  SETTINGS_STAFF_MANAGEMENT: "SETTINGS.STAFF.MANAGEMENT",

  // ✅ Template Builder workspace (align with Permission.Code)
  TEMPLATE_WORKSPACE_VIEW: "TEMPLATE.WORKSPACE.VIEW",
  TEMPLATE_BUILDER_VIEW: "TEMPLATE.BUILDER.VIEW",
  TEMPLATE_BUILDER_CREATE_DRAFT: "TEMPLATE.BUILDER.CREATE.DRAFT",
  TEMPLATE_BUILDER_APPROVED_TEMPLATES_VIEW:
    "TEMPLATE.BUILDER.APPROVED.TEMPLATES.VIEW",
  TEMPLATE_BUILDER_LIBRARY_BROWSE: "TEMPLATE.BUILDER.LIBRARY.BROWSE",
};
